import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class BnSessionTimeoutService {
  constructor(
    private readonly oAuthService: OAuthService,
    protected httpClient: HttpClient
  ) {}

  logout() {
    this.oAuthService.revokeTokenAndLogout().then(() => {
      this.oAuthService.initLoginFlow();
    });
  }

  goToLoginPage() {
    this.oAuthService.revokeTokenAndLogout().then(() => {
      this.oAuthService.initLoginFlow();
    });
  }

  loginEvent(serviceagreementId: string, userId: string){
    return this.httpClient.post('/api/bss-event-listener/client-api/v2/loginevent', { serviceagreementId, userId });
  }
}
